import React, { useEffect, useState } from 'react';
import moment from 'moment'
import './recordings-styles.css';
import { Modal, Button } from 'react-bootstrap';
import { BASE_URL, Endpoints } from '../../constants/urls';
import axios from 'axios';
import { colorTheme } from '../../utilities/ColorTheme';
import { faCalendarAlt, faMicrophone, faFilePowerpoint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactPlayer from 'react-player';
import Slider from "react-slick";
import {convertUTCDateToLocalDateStringFormat} from '../../utilities/DateTimeToLocalDateTime'
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
export const RecordingsPage = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [events, setEvents] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showEventDetails, setShowEventDetails] = useState(false);
  const [selectedItem, setSelectedItem] = useState();

  const getSlidesToShow = (width) => {
    if (width > 1300) {
      return 3;
    }
    else if (width > 1024) {
      return 3;
    } else if (width > 768) {
      return 2;
    } else {
      return 1;
    }
  };
  const [slidesToShoww, setSlidesToShoww] = useState(getSlidesToShow(window.innerWidth));


  useEffect(() => {
    const handleResize = () => {
      setSlidesToShoww(getSlidesToShow(window.innerWidth));
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShoww,
    slidesToScroll: 1,
    autoplay: true,      
    autoplaySpeed: 4000, 

  };

  const handleVideoClick = (video) => {
    setSelectedVideo(video);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedVideo(null);
  };
  useEffect(() => {
    fetchPastEvents();
  }, []);
  const fetchPastEvents = async () => {
    setLoading(true);
    const url = BASE_URL + Endpoints.GetPastEventsRecordings;
    try {
      const response = await axios.get(url);
      console.log('*****', response);
      setEvents(response.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };
  const items = events.map((event) => (
    <>
      <div
        key={event.id}
        className='custom-event-card'
        onClick={() => {
          setSelectedVideo(event);
        }}
      >
        <div className='custom-event-image' style={{ height: "230px" }}>
          <ReactPlayer
            url={event.recordingURL}
            width='100%'
            height='100%'
            controls
            playing={false}
          />

        </div>
        <div className='custom-event-info'>
          <h2 className='custom-event-name'>{event.title}</h2>
          <p className='custom-event-date mb-0'>
            <b> {convertUTCDateToLocalDateStringFormat(event.date, false, 'LL')}</b>
          </p>
          {
            event.materialURL != '' ? <p className='full-w custom-event-speaker mb-0'>
              <a href={event.materialURL}>Presentation Material</a> </p>
              : null
          }

          <p className='custom-event-speaker mb-0 full-w'>
            <b> Speaker:</b> {event.speakerName}
          </p>
        </div>
      </div>
    </>

    
))

const responsive = {
  0: { items: 1 },
  568: { items: 2 },
  1024: { items: 3 },
};
  return (
    <div className=''>
      <div
        className=''
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {/* <img
          className='recording-logo'
          src={require('../../assets/app-logo.png')}
        /> */}
      </div>
      <div className='custom-container'>
        {/* <h2
          style={{ paddingBottom: 10, marginTop: -10 }}
          className='expect-heading text-black '
        >
          Previous Events{' '}
          <span className='text-warning head-font'>Recordings</span>
        </h2> */}

        <div class=''>
          <h2 class='expect-heading text-black  pb-1 mb-2 bar'>
            Missed Our <span class='text-theme head-font'> Last Event??</span>
          </h2>
          <p class='l-desc'>
            Don’t worry—catch up on all the valuable insights at your own pace!
          </p>
          </div>
          {loading && (
          <div className='custom-event-grid'>
            {[1, 1, 1].map((x) => (
              <div className='custom-event-card'>
                <div className='sk sk-img'></div>
                <div className='custom-event-info sk-info'>
                  <h2 className='sk mt-2 mb-2'></h2>
                  <p className='sk mb-2'></p>
                  <p className='sk mb-0'></p>
                </div>
              </div>
            ))}
          </div>
        )}
        {!loading && events?.length > 0 && (
           <div className='d-flex gap-5 justify-content-center flex-wrap'>
           <p class='l-event-name mb-0'>
             {' '}
             <b class=''>Previous Event Topic:</b> {events[events.length - 1].title}
           </p>
          
         </div>
        )}

        <div className='custom-event-grid1'>
            {!loading &&   events.length > 0 ?
          // <Slider {...settings}>
          //     {
               
          //     }
            
            


          // </Slider>

          <AliceCarousel
          mouseTracking
          items={items}
          infinite
          disableDotsControls
          autoPlay = {false}
          autoPlayInterval={3500}
          animationDuration={700}
          responsive={responsive}
          controlsStrategy="alternate"
          renderPrevButton={() => (
            <button className="custom-prev-button">&#8249;</button>
          )}
          renderNextButton={() => (
            <button className="custom-next-button">&#8250;</button>
          )}
      />
            :
            <div>
              <img width={100} src={require('../../assets/No-Data.png')} />
              <h6 className='mt-3 text-theme'>No Missed Event</h6>
              <p>No missed event right now. Keep visiting to catch the next one!
              </p>
            </div>
            }

        </div>

        {selectedVideo && (
          <Modal show={showModal} onHide={handleCloseModal} centered size='xl'>
            <Modal.Header closeButton>
              <Modal.Title>{selectedVideo.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ width: '100%' }}>
              <video
                src={selectedVideo.recordingURL}
                controls
                autoPlay
                className='video-player'
              >
                Your browser does not support the video tag.
              </video>
            </Modal.Body>
            <Modal.Footer>
              <Button className='reidPrimaryBtn btn' onClick={handleCloseModal}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </div>
  );
};
